import SearchIcon from '@mui/icons-material/Search';
import { Autocomplete, Box, Button, InputAdornment, MenuItem, Select, TextField } from '@mui/material';
import { FunctionComponent } from 'react';
import { useQuestionFilters } from './QuestionFilterContext';

type Props = {
	allTags: string[];
	allAuthors: string[];
};

/** Component presenting filter controls for Questions and QuestionSets */
export const FilterControls: FunctionComponent<Props> = (props) => {
	const {
		filterActive, setFilterActive,
		filterTags, setFilterTags,
		filterAuthor, setFilterAuthor,
		searchText, setSearchText,
		gridFilterModel,
		clearFilters,
	} = useQuestionFilters();

	const hasGridFilters = !gridFilterModel.items.empty();
	const hasActiveFilters: boolean = (filterActive !== undefined) || !filterTags.empty() || !!filterAuthor || !!searchText || hasGridFilters;

	function handleActiveChange(value: string) {
		if (value === 'all') {
			setFilterActive(undefined);
		} else if (value === 'active') {
			setFilterActive(true);
		} else {
			setFilterActive(false);
		}
	}

	function getActiveValue() {
		return (filterActive === undefined)
			? 'all'
			: (filterActive ? 'active' : 'inactive');
	}

	return <Box role='search' sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', alignItems: 'center' }}>
		<TextField
			size="small"
			label="Search"
			role='searchbox'
			value={searchText}
			onChange={(e) => setSearchText(e.target.value)}
			sx={{ minWidth: 200 }}
			slotProps={{
				input: {
					startAdornment: (
						<InputAdornment position="start">
							<SearchIcon />
						</InputAdornment>
					),
				},
			}}
		/>

		<Select
			aria-label='Filter by active or inactive' role='searchbox'
			size="small"
			value={getActiveValue()}
			onChange={(e) => handleActiveChange(e.target.value)}
			sx={{ minWidth: 120 }}
		>
			<MenuItem value="all">All</MenuItem>
			<MenuItem value="active">Active</MenuItem>
			<MenuItem value="inactive">Inactive</MenuItem>
		</Select>

		<Autocomplete
			multiple
			size="small"
			options={props.allTags}
			value={filterTags}
			onChange={(_, newValue) => setFilterTags(newValue)}
			renderInput={(params) => <TextField {...params} label="Filter by Tags" role='searchbox' />}
			sx={{ minWidth: 250 }}
		/>

		<Autocomplete
			size="small"
			options={props.allAuthors}
			value={filterAuthor}
			onChange={(_, newValue) => setFilterAuthor(newValue ?? '')}
			renderInput={(params) => <TextField {...params} label="Filter by Author" role='searchbox' />}
			sx={{ minWidth: 200 }}
		/>

		{hasActiveFilters && <Button size="small" onClick={clearFilters}>
			Clear Filters
		</Button>}
	</Box>;
};
